export default {
    Priority: {
        IMPORTANT: "important",
        NORMAL: "normal",
    },
    recordAction(data, prority) {
        window.opr?.statsPrivate.recordAction(data, prority);
    },
    recordSessionEvent(path, data, priority) {
        window.opr?.statsPrivate.recordSessionEvent(path, data, priority);
    },
    recordIntegerValue(path, value, priority) {
        window.opr?.statsPrivate.recordIntegerValue(path, value, priority);
    },
    recordStringValue(path, value, priority) {
        window.opr?.statsPrivate.recordStringValue(path, value, priority);
    },
    recordBooleanValue(path, value, priority) {
        window.opr?.statsPrivate.recordBooleanValue(path, value, priority);
    },
};
